// Guardar un objeto en localStorage
export const saveToLocalStorage = (key, value) => {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
      console.error("Error al guardar en localStorage:", error);
    }
  };
  
  // Recuperar un objeto desde localStorage
  export const getFromLocalStorage = (key) => {
    try {
      const serializedValue = localStorage.getItem(key);
      return serializedValue ? JSON.parse(serializedValue) : null;
    } catch (error) {
      console.error("Error al recuperar desde localStorage:", error);
      return null;
    }
  };
  
  // Eliminar un elemento de localStorage
  export const removeFromLocalStorage = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Error al eliminar desde localStorage:", error);
    }
  };
  
  // Limpiar todo el localStorage
  export const clearLocalStorage = () => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("Error al limpiar localStorage:", error);
    }
  };
  